import {connect} from 'react-redux';
import SupporterDetailsBlock from '../../../components/blocks/supporter/SupporterDetailsBlock';
import moment from 'moment';
import {
    getSupporter,
    changeValue,
    editSupporterDetails,
    saveSupporterDetails,
    toggleBooleanValue
} from '../../../actions/supporterDetailsAction';

const mapStateToProps = (state, ownProps) => {
    return {
        supporterId: ownProps.supporterId,
        supporterDetails: state.supporterDetails
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getSupporter(id) {
            dispatch(getSupporter(id))
        },
        handleTextInputChange(e) {
            dispatch(changeValue(e.target.name, e.target.value))
        },
        handleCheckboxChange(e) {
            dispatch(toggleBooleanValue(e.target.name))
        },
        handleBirthdayChange(date) {
            dispatch(changeValue('birthday', moment(date).format('DD.MM.YYYY')))
        },
        editSupporter() {
            dispatch(editSupporterDetails())
        },
        handleFormSubmit(data) {
            dispatch(saveSupporterDetails(data))
        }
    }
};

const SupporterDetailsBlockContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SupporterDetailsBlock);

export default SupporterDetailsBlockContainer;